import { SESSION_STORAGE_KEY } from "@/utils/persistentSession"

export default defineNuxtPlugin(async () => {
  const session = useAuthSession()
  const renew = () => session.ensure().catch(() => { /* Preserve session on offline/temporary failures. */ })
  await renew()
  window.addEventListener("online", renew)
  document.addEventListener("visibilitychange", () => { if (!document.hidden) renew() })
  window.addEventListener("storage", event => { if (event.key === SESSION_STORAGE_KEY) session.read() })
})
